import { render } from "./copyright-count.vue?vue&type=template&id=394631b4&scoped=true"
import script from "./copyright-count.vue?vue&type=script&lang=js"
export * from "./copyright-count.vue?vue&type=script&lang=js"

import "./copyright-count.vue?vue&type=style&index=0&id=394631b4&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394631b4"]])

export default __exports__